var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 16,
  viewBox: "0 0 21 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.48299 12.9304L2.13384 8.5153C1.89967 8.27705 1.58176 8.14315 1.25022 8.14315C0.918689 8.14315 0.600774 8.27705 0.366607 8.5153C-0.122202 9.01152 -0.122202 9.81311 0.366607 10.3093L5.60564 15.6278C6.09445 16.1241 6.88407 16.1241 7.37287 15.6278L20.6334 2.16619C21.1222 1.66996 21.1222 0.868372 20.6334 0.372149C20.3992 0.133895 20.0813 0 19.7498 0C19.4182 0 19.1003 0.133895 18.8662 0.372149L6.48299 12.9304Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-icon.44e811ec.svg";
export { ForwardRef as ReactComponent };